import { Box, Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'

export default function NotFoundMessage({ isNewTab = false }: { isNewTab?: boolean }) {
  return (
    <Box textAlign="center">
      {isNewTab ? (
        <Typography variant="h6">正常なリンクから遷移した画面ではありません。</Typography>
      ) : (
        <Typography variant="h6">
          このページは表示するデータがありません
          <br />
          すでに削除された可能性があります。
        </Typography>
      )}
      <Box marginTop={2}>
        <Button variant="outlined" component={Link} to="..">
          戻る
        </Button>
      </Box>
    </Box>
  )
}
